import styled from 'styled-components';
import {commonPalette} from '@swipe-guide/clients-shared/styles/palette';

export const TopicsWrapper = styled.div``;

export const TopicWrapper = styled.div``;

export const FeedbackWrapper = styled.div`
  float: right;
`;
export const LastPublishedAt = styled.div`
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 12px;
  color: ${commonPalette.textSecondary};
`;
